import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var AccountSettings = t.type({
  email: t.string,
  confirmPassword: t.string
});
export var ChangePassword = t.type({
  currentPassword: t.string,
  newPassword: t.string,
  newPasswordConfirmation: t.string
});
export var Error = t.type({
  message: t.string,
  __typename: t.keyof({
    NotFoundError: null,
    UnprocessableEntityError: null,
    InvalidEmailError: null,
    SameEmailError: null,
    EmailTakenError: null,
    IncorrectPasswordError: null,
    PasswordValidationError: null,
    CannotReusePasswordError: null
  })
});
export var UpdateSettingsInput = t.type({
  input: t.type({
    name: t.string,
    newEmail: t.type({
      email: t.string,
      confirmPassword: t.string
    })
  })
});
export var UpdateSettingsOutput = t.type({
  editProfile: t.union([t.type({
    __typename: t.literal('EditProfileErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditProfileResult'),
    result: t.type({
      email: t.string
    })
  })])
});
export var ChangePasswordInput = t.type({
  input: t.type({
    name: t.string,
    newPassword: nullable(t.type({
      password: t.string,
      oldPassword: t.string
    }))
  })
});
export var ChangePasswordOutput = t.type({
  editProfile: t.union([t.type({
    __typename: t.literal('EditProfileErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditProfileResult')
  })])
});
export var ResetPasswordOutput = t.type({
  resetPassword: t.union([t.type({
    __typename: t.literal('ResetPasswordError'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('ResetPasswordResult'),
    message: t.string
  })])
});
export var DeleteMyAccountOutput = t.type({
  deleteMyAccount: t.union([t.type({
    __typename: t.literal('DeleteMyAccountError'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('DeleteMyAccountResult'),
    message: t.string
  })])
});